import { AssetType } from 'models/asset/asset';

/**
 * A common asset name from the global reference list, such as Microsoft Intune, that the add field of an asset inquiry
 * suggests. Never the organisation's own list: a picked name becomes an ordinary line.
 */
export class AssetTemplate {
  id: number;

  name: string;

  description?: string;

  assetType: AssetType;

  categoryId: number;

  category?: string;

  categoryDescription?: string;

  // the register asset with the template's name in one of the organization's languages: the template is in the
  // register already and the catalogue does not add it again (PLAN-073, spec 3.2)
  existingAssetId?: number;

  existingAssetName?: string;

  constructor() {
    this.id = 0;
    this.name = '';
    this.assetType = AssetType.Information;
    this.categoryId = 0;
  }
}
